var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalmTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.586 24.1716C31.1955 23.7811 30.5623 23.7811 30.1718 24.1716C29.7813 24.5621 29.7813 25.1953 30.1718 25.5858L31.586 27L30.1718 28.4142C29.7813 28.8048 29.7813 29.4379 30.1718 29.8284C30.5623 30.219 31.1955 30.219 31.586 29.8284L33.0002 28.4142L34.4144 29.8284C34.805 30.219 35.4381 30.219 35.8287 29.8284C36.2192 29.4379 36.2192 28.8048 35.8287 28.4142L34.4144 27L35.8287 25.5858C36.2192 25.1953 36.2192 24.5621 35.8287 24.1716C35.4381 23.7811 34.805 23.7811 34.4144 24.1716L33.0002 25.5858L31.586 24.1716Z",
    fill: "#006FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 6.89543 15.8954 6 17 6H23C24.1046 6 25 6.89543 25 8V10H36C37.1046 10 38 10.8954 38 12V15.9686C38.0007 15.9899 38.0007 16.0112 38 16.0324V22.101C39.2372 23.3636 40 25.0927 40 27C40 30.866 36.866 34 33 34C31.0927 34 29.3636 33.2372 28.101 32H4C2.89543 32 2 31.1046 2 30V16.0006C2 16.0006 2 16.0005 2 16.0006V12C2 10.8954 2.89543 10 4 10H15V8ZM4 17.3257V30H26.6736C26.2417 29.0907 26 28.0736 26 27C26 23.134 29.134 20 33 20C34.0736 20 35.0907 20.2417 36 20.6736V17.3258L24 20.7544V21C24 22.1046 23.1046 23 22 23H18C16.8954 23 16 22.1046 16 21V20.7542L4 17.3257ZM16.0252 18.6814L4 15.2456V12H36V15.2458L23.9748 18.6816C23.8223 17.7283 22.9962 17 22 17H18C17.0039 17 16.1778 17.7283 16.0252 18.6814ZM18 20.0315C18.0007 20.0101 18.0007 19.9888 18 19.9675V19H22V21H18V20.0315ZM23 8V10H17V8H23ZM36 22.9996C37.2144 23.9118 38 25.3642 38 27C38 29.7614 35.7614 32 33 32C31.3642 32 29.9118 31.2144 28.9996 30C28.3719 29.1643 28 28.1256 28 27C28 24.2386 30.2386 22 33 22C34.1256 22 35.1643 22.3719 36 22.9996Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmTree);
export default __webpack_public_path__ + "static/media/palm-tree.dd49922788b623e7fefb95300fea8fc6.svg";
export { ForwardRef as ReactComponent };